<div class="row justify-content-center" [ngClass]="routeAnimationsElements">
    <div class="col-md-8">
        <mat-card>
            <rpe-persona-form [formInput]="formInput" (formValueChanges)="formValueChanges($event)"
                (formStatusChanges)="formStatusChanges($event)"></rpe-persona-form>
            <div class="row buttons d-flex justify-content-between pad" [ngClass]="routeAnimationsElements">
                <!--<button type="reset" (click)="onCancel()" mat-raised-button>
                    Cancelar
                </button>-->
                <button type="submit" mat-raised-button (click)="onSubmit()" color="primary">
                    Confirmar
                </button>
            </div>
        </mat-card>
    </div>
</div>